import Vue from '../../utils/vue';
import { mergeData } from 'vue-functional-data-merge';
export var props = {}; // @vue/component

export var BNavText = /*#__PURE__*/Vue.extend({
  name: 'BNavText',
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;
    return h('li', mergeData(data, {
      staticClass: 'navbar-text'
    }), children);
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/nav/nav-text.js
// module id = 359
// module chunks = 44